// Name: Events Service Custom Render Components

export const ACTION_ITEM_CUSTOM_RENDER_COMPONENTS = {};
export const EVENT_HOOK_CUSTOM_RENDER_COMPONENTS = {};
export const EVENT_CUSTOM_RENDER_COMPONENTS = {};
export const NOTIFICATION_CUSTOM_RENDER_COMPONENTS = {};
